export interface CheckpointNote {
  _id: string;
  text: string;
  createdBy: string;
  createdAt: string;
}

export interface CheckpointField {
  date: string | null;
  declined: boolean;
  confirmed?: boolean;
  format: string | null;
  notes: CheckpointNote[];
  groupIds?: string[];
}

export class SchoolHealthModel {

  _id: string;
  schoolId: string;
  schoolName: string;
  organizationId: string;
  organizationName: string;
  country: string;
  schoolYearId: string;
  numLicenses: number;
  numLicensesUsed: number;
  numLicensesActivated: number;
  numLicensesAvailable: number;
  licenseStartsAt: string;
  licenseExpiresAt: string;
  numGroups: number;
  numGroupsWithObjective: number;
  numGroupsRequiringReview: number;
  numGroupsWithUnresolvedReview: number;
  numTeachers: number;
  numTeachersLoggedInLast30Days: number;
  numStudents: number;
  numStudentsWithPrimaryGroup: number;
  numStudentsWhoCompletedPlacementTest: number;
  hasAnyGroupSetUp: boolean;
  hasAnyObjectiveAssigned: boolean;
  hasAnyStudentStarted: boolean;
  hasAnyPlacementTestCompleted: boolean;
  firstAnswerDate: string;
  lastAnswerDate: string;
  numAnswersTodayLive: number;
  numAnswersLast7Days: number;
  numAnswersLast30Days: number;
  numActiveStudentsLast7Days: number;
  numActiveStudentsLast30Days: number;
  numActiveGroupsLast30Days: number;
  avgAnswersPerStudentLast30Days: number;
  totalAnswerTimeLast30Days: number;
  numAnswersThisYear: number;
  numCorrectThisYear: number;
  numActiveStudentsThisYear: number;
  numActiveDaysThisYear: number;
  totalAnswerTimeThisYear: number;
  licenseSetup: CheckpointField;
  groupsAndStudentSetup: CheckpointField;
  teacherTraining: CheckpointField;
  bookOrder: CheckpointField;
  studentOnboarding: CheckpointField;
  createdAt: string;
  updatedAt: string;

  static generate(data: any): SchoolHealthModel {
    const m = new SchoolHealthModel();
    if (!data) {
      return m;
    }
    m._id                                  = data._id;
    m.schoolId                             = data.schoolId;
    m.schoolName                           = data.schoolName;
    m.organizationId                       = data.organizationId;
    m.organizationName                     = data.organizationName;
    m.country                              = data.country;
    m.schoolYearId                         = data.schoolYearId;
    m.numLicenses                          = data.numLicenses;
    m.numLicensesUsed                      = data.numLicensesUsed;
    m.numLicensesActivated                 = data.numLicensesActivated;
    m.numLicensesAvailable                 = data.numLicensesAvailable;
    m.licenseStartsAt                      = data.licenseStartsAt;
    m.licenseExpiresAt                     = data.licenseExpiresAt;
    m.numGroups                            = data.numGroups;
    m.numGroupsWithObjective               = data.numGroupsWithObjective;
    m.numGroupsRequiringReview             = data.numGroupsRequiringReview;
    m.numGroupsWithUnresolvedReview        = data.numGroupsWithUnresolvedReview;
    m.numTeachers                          = data.numTeachers;
    m.numTeachersLoggedInLast30Days        = data.numTeachersLoggedInLast30Days;
    m.numStudents                          = data.numStudents;
    m.numStudentsWithPrimaryGroup          = data.numStudentsWithPrimaryGroup;
    m.numStudentsWhoCompletedPlacementTest = data.numStudentsWhoCompletedPlacementTest;
    m.hasAnyGroupSetUp                     = data.hasAnyGroupSetUp;
    m.hasAnyObjectiveAssigned              = data.hasAnyObjectiveAssigned;
    m.hasAnyStudentStarted                 = data.hasAnyStudentStarted;
    m.hasAnyPlacementTestCompleted         = data.hasAnyPlacementTestCompleted;
    m.firstAnswerDate                      = data.firstAnswerDate;
    m.lastAnswerDate                       = data.lastAnswerDate;
    m.numAnswersTodayLive                  = data.numAnswersTodayLive;
    m.numAnswersLast7Days                  = data.numAnswersLast7Days;
    m.numAnswersLast30Days                 = data.numAnswersLast30Days;
    m.numActiveStudentsLast7Days           = data.numActiveStudentsLast7Days;
    m.numActiveStudentsLast30Days          = data.numActiveStudentsLast30Days;
    m.numActiveGroupsLast30Days            = data.numActiveGroupsLast30Days;
    m.avgAnswersPerStudentLast30Days       = data.avgAnswersPerStudentLast30Days;
    m.totalAnswerTimeLast30Days            = data.totalAnswerTimeLast30Days;
    m.numAnswersThisYear                   = data.numAnswersThisYear;
    m.numCorrectThisYear                   = data.numCorrectThisYear;
    m.numActiveStudentsThisYear            = data.numActiveStudentsThisYear;
    m.numActiveDaysThisYear                = data.numActiveDaysThisYear;
    m.totalAnswerTimeThisYear              = data.totalAnswerTimeThisYear;
    m.licenseSetup                         = data.licenseSetup          || null;
    m.groupsAndStudentSetup                = data.groupsAndStudentSetup || null;
    m.teacherTraining                      = data.teacherTraining       || null;
    m.bookOrder                            = data.bookOrder             || null;
    m.studentOnboarding                    = data.studentOnboarding     || null;
    m.createdAt                            = data.createdAt;
    m.updatedAt                            = data.updatedAt;
    return m;
  }

  static generateList(data: any[]): SchoolHealthModel[] {
    if (!data) {
      return [];
    }
    return data.map(d => SchoolHealthModel.generate(d));
  }
}

export class SchoolHealthFilter {
  country: string;
  organizationId: string;
  schoolYearId: string;
}
